import { render, staticRenderFns } from "./Fase6.vue?vue&type=template&id=15e6b13c&scoped=true"
import script from "./Fase6.vue?vue&type=script&lang=js"
export * from "./Fase6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e6b13c",
  null
  
)

export default component.exports